/**
 * Patient questionnaire page bundle.
 *
 * @package LecardoVein
 */

import { initPatientQuestionnaire } from './components/patient-questionnaire';

window.addEventListener('load', () => {
	initPatientQuestionnaire();
});

['wpcf7mailsent', 'wpcf7invalid', 'wpcf7spam', 'wpcf7mailfailed'].forEach(
	(event_name) => {
		document.addEventListener(event_name, () => {
			initPatientQuestionnaire();
		});
	}
);
